module.exports = {
      id: "icon-google-play-usage",
      viewBox: "0 0 12.598 13.975",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-google-play",
      toString: function () {
        return this.url;
      }
    }